module.exports = __webpack_public_path__ + "static/media/personalColoring.ef289096.gif";